import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

if (typeof window !== "undefined") {
  window.learningGamesInstallPrompt = window.learningGamesInstallPrompt || null;

  window.addEventListener("beforeinstallprompt", (event) => {
    event.preventDefault();
    window.learningGamesInstallPrompt = event;
    window.dispatchEvent(
      new CustomEvent("learninggames:install-ready", { detail: event }),
    );
  });

  window.addEventListener("appinstalled", () => {
    window.learningGamesInstallPrompt = null;
    window.dispatchEvent(new Event("learninggames:installed"));
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {
      // Install support is optional; the site still works normally without it.
    });
  });
}
